function createObject() {
  let example = {
    id: "PfadeWeiterzaehlen",
    workOrder: `
            Wählen Sie aus den vier Diagnoseaufgaben zunächst genau zwei aus. Betrachen Sie dann die Lösungen und entscheiden Sie sich für genau eine - möglichst passgenaue - Förderaufgabe.
            `,
    audio: require("@/assets/nzr/Pfade/Weiterzaehlen/01.mp3"),
    imageSizePercent: 30,
    mediaDescription:
      'Die Schülerin Lena bearbeitet die Aufgabe "Bilde das Doppelte der 12".',
    pupilName: "Lena",
    elements: [
      [
        {
          selectCount: 2,
          typeText: "Diagnoseaufgabe",
          question:
            "Wählen Sie nun <u>genau zwei</u> weitere Diagnoseaufgaben aus, zu denen Sie die Lösung sehen möchten, um die Diagnose zu vertiefen.",
          diagnostics: [
            {
              id: 1,
              taskImage: require("@/assets/nzr/Pfade/Weiterzaehlen/02.png"),
              solutionImage: require("@/assets/nzr/Pfade/Weiterzaehlen/03.png"),
            },
            {
              id: 2,
              taskImage: require("@/assets/nzr/Pfade/Weiterzaehlen/04.png"),
              solutionImage: require("@/assets/nzr/Pfade/Weiterzaehlen/05.png"),
            },
            {
              id: 3,
              taskImage: require("@/assets/nzr/Pfade/Weiterzaehlen/06.png"),
              solutionImage: require("@/assets/nzr/Pfade/Weiterzaehlen/07.png"),
            },
            {
              id: 4,
              taskImage: require("@/assets/nzr/Pfade/Weiterzaehlen/08.png"),
              solutionImage: require("@/assets/nzr/Pfade/Weiterzaehlen/09.png"),
            },
          ],
        },
      ],
      [
        // this is stage 2 (föderaufgabe)
        {
          selectCount: 1,
          typeText: "Förderaufgabe",
          question:
            "Wählen Sie nun <u>eine</u> passende Förderaufgabe aus, die zu Ihren gewählten Diagnoseaufgaben passt.",
          diagnostics: [
            {
              id: 1,
              taskImage: require("@/assets/nzr/Pfade/Weiterzaehlen/10.png"),
            },
            {
              id: 2,
              taskImage: require("@/assets/nzr/Pfade/Weiterzaehlen/11.png"),
            },
            {
              id: 3,
              taskImage: require("@/assets/nzr/Pfade/Weiterzaehlen/12.png"),
            },
            {
              id: 4,
              taskImage: require("@/assets/nzr/Pfade/Weiterzaehlen/13.png"),
            },
          ],
        },
      ],
    ],
  };

  const DA_1 = "Diagnoseaufgabe 1 zeigt, dass Lena die Anzahl ermittelt, indem sie vom ersten Summanden ausgehend um den zweiten Summanden weiterzählt. Da sie den ersten Summanden mitzählt, ist ihr Ergebnis um 1 zu gering („Minus-Eins-Fehler“). ";

  const DA_2 = "Diagnoseaufgabe 2 lässt erkennen, dass Lenas Ergebnis um 1 zu gering ist, was auf den „Minus-Eins-Fehler“ hindeuten könnte: Sie zählt bei der Anzahlbestimmung den ersten Summanden bereits mit, anstatt bei deren Nachfolger zu beginnen. ";

  const DA_3 = "Lenas Ergebnis ist in der dritten Diagnoseaufgabe um 1 zu gering. Die Grunde hierfür könnten vielfältig sein – eine eindeutige Diagnose ist hiermit nicht möglich. ";

  const DA_4 = "In der vierten Diagnoseaufgabe ist das Ergebnis um 1 zu gering. Die eingezeichneten Punkte unterhalb des Zahlenstrahls weisen auf eine zählende Vorgehensweise hin (Weiterzählen vom ersten Summand). Ursache der zu geringen Summe könnte der „Minus-Eins-Fehler“ sein. ";

  const FA_1 = "Förderaufgabe 1 spricht die Teil-Ganzes-Beziehung an. Hierbei kann Lena die möglichen Zerlegungen der 10 auf systematische Weise ergründen, beispielsweise indem sukzessive die Farbe eines Plättchens vertauscht wird (operative Veränderung). Zugleich kann die Konstanz der Summe erfahren werden. Sie muss somit nicht auf zählende Strategien zurückgreifen. ";

  const FA_2 = "Förderaufgabe 2 ist strukturell ähnlich zur zweiten und dritten Diagnoseaufgabe. Es ist nicht zu erwarten, dass Lena in dieser einen Erkenntniszuwachs erzielen kann. ";

  const FA_3 = "Förderaufgabe 3 versucht, Aufgabenbeziehungen in den Blick zu nehmen. Lena kann durch Ausnutzung benachbarter, „einfacherer“ Aufgaben (z.B. 7+7 [Gegensinniges Verändern] oder 10+6 [Hilfsaufgabe]) diese Additionsaufgabe lösen, ohne auf zählende Vorgehensweisen zurückgreifen zu müssen. Ob ihr dies ohne Materialunterstützung gelingt, ist jedoch fraglich. ";

  const FA_4 = "Förderaufgabe 4 vertieft Lenas Verständnis für die Struktur des Zahlenstrahls, indem sie angeregt wird, den ersten Summanden zu erkennen. Da vor dem Hintergrund der Diagnose jedoch naheliegt, dass sie vom ersten Summanden weiterzählt, unterstützt diese Aufgabe sie nicht bei der Ablösung vom zählenden Rechnen. Bei der Reflexion der anderen Vorgehensweise kann Lena ihre Strategie vom Alleszählen abgrenzen, was ebenfalls jedoch nicht zu Lenas Ablösung vom zählenden Rechnen beiträgt. ";

  const PASSUNG_SEHR_GUT = `
        Diese Förderaufgabe passt sehr gut zur Diagnose.
        <br />
        `
    const PASSUNG_GUT = `
        Diese Förderaufgabe passt ganz gut zur Diagnose.
        <br />
        `
    const PASSUNG_SCHLECHT = `
        Diese Förderaufgabe hätten wir nach der Diagnose eher nicht gewählt.
        <br />
        `

    const PASSUNG_SEHR_SCHLECHT = `
        Diese Aufgabe hätten wir nicht gewählt.
        <br />
        `

    example.responses = [{
            id: '112',
            text: PASSUNG_SEHR_GUT + DA_1 + DA_2 + FA_1
        },
        {
            id: '113',
            text: PASSUNG_SEHR_GUT + DA_1 + DA_3 + FA_1
        },
        {
            id: '114',
            text: PASSUNG_SEHR_GUT + DA_1 + DA_4 + FA_1
        },
        {
            id: '123',
            text: PASSUNG_SEHR_GUT + DA_2 + DA_3 + FA_1
        },
        {
            id: '124',
            text: PASSUNG_SEHR_GUT + DA_2 + DA_4 + FA_1
        },
        {
            id: '134',
            text: PASSUNG_SEHR_GUT + DA_3 + DA_4 + FA_1
        },
        {
            id: '212',
            text: PASSUNG_SEHR_SCHLECHT + DA_1 + DA_2 + FA_2
        },
        {
            id: '213',
            text: PASSUNG_SEHR_SCHLECHT + DA_1 + DA_3 + FA_2
        },
        {
            id: '214',
            text: PASSUNG_SEHR_SCHLECHT + DA_1 + DA_4 + FA_2 + "Es ist nicht zu erwarten, dass Lena die Aufgabe auf symbolischer Ebene ohne „Minus-Eins-Fehler“ und zählende Vorgehensweise lösen wird, da dies auch auf ikonischer Ebene nicht gelungen ist."
        },
        {
            id: '223',
            text: PASSUNG_SEHR_SCHLECHT + DA_2 + DA_3 + FA_2
        },
        {
            id: '224',
            text: PASSUNG_SEHR_SCHLECHT + DA_2 + DA_4 + FA_2
        },
        {
            id: '234',
            text: PASSUNG_SEHR_SCHLECHT + DA_3 + DA_4 + FA_2
        },
        {
            id: '312',
            text: PASSUNG_GUT + DA_1 + DA_2 + FA_3
        },
        {
            id: '313',
            text: PASSUNG_GUT + DA_1 + DA_3 + FA_3
        },
        {
            id: '314',
            text: PASSUNG_GUT + DA_1 + DA_4 + FA_3
        },
        {
            id: '323',
            text: PASSUNG_SCHLECHT + DA_2 + DA_3 + FA_3
        },
        {
            id: '324',
            text: PASSUNG_SCHLECHT + DA_2 + DA_4 + FA_3
        },
        {
            id: '334',
            text: PASSUNG_SCHLECHT + DA_3 + DA_4 + FA_3
        },
        {
            id: '412',
            text: PASSUNG_SCHLECHT + DA_1 + DA_2 + FA_4
        },
        {
            id: '413',
            text: PASSUNG_SCHLECHT + DA_1 + DA_3 + FA_4
        },
        {
            id: '414',
            text: PASSUNG_SEHR_SCHLECHT + DA_1 + DA_4 + FA_4
        },
        {
            id: '423',
            text: PASSUNG_SCHLECHT + DA_2 + DA_3 + FA_4
        },
        {
            id: '424',
            text: PASSUNG_SEHR_SCHLECHT + DA_2 + DA_4 + FA_4
        },
        {
            id: '434',
            text: PASSUNG_SEHR_SCHLECHT + DA_3 + DA_4 + FA_4
        },
    ]

  return example;
}

export default createObject();
